import { AxiosService } from './axios.service'

const baseUrl = 'identidade/'

const post = (url) => (value) => AxiosService.post(baseUrl + url, value)

export class AuthenticationService {
	/**
	 * Autentica o usuário com as credenciais fornecidas
	 * @param {string} login e-mail, cpf ou número moveflex
	 * @param {string} password senha
	 * @returns sucesso ou falha ao autenticar e lista de erros
	 */
	static authenticate(login, password) {
		return post('autenticar')({
			login,
			password,
		}).then(({ data }) => data)
	}

	/**
	 * Faz login com o usuário através de login social
	 * @param {string} provider google, facebook etc
	 * @param {string} tokenId tokenId retornado de autenticação com provider
	 * @returns sucesso ou falha ao logar e lista de erros
	 */
	static socialLogin(provider, object) {
		return post(`autenticar/${provider}`)(object).then(({ data }) => data)
	}

	/**
	 * Autentica o usuário com as credenciais fornecidas
	 * @param {string} login e-mail, cpf ou número moveflex
	 * @returns sucesso ou falha ao encontrar login e lista de erros
	 */
	static requestPasswordReset(login) {
		return post('solocitar-alteracao-de-senha')({ login }).then(
			({ data }) => data
		)
	}

	/**
	 * Autentica o usuário com as credenciais fornecidas
	 * @param {string} login e-mail, cpf ou número moveflex
	 * @param {string} password senha
	 * @returns sucesso ou falha ao reenviar e-mail e lista de erros
	 */
	static resendEmailConfirmation(login, password) {
		return post('reenviar-email-de-confirmacao')({
			login,
			password,
		}).then(({ data }) => data)
	}

	/**
	 * Refreshs the user authentication
	 * @param {string} userId The user identifier
	 * @param {string} refreshToken The refresh token that user earned on login
	 */
	static refreshToken(userId, refreshToken) {
		return post('atualizar-token')({
			userId,
			refreshToken,
		}).then(({ data }) => data)
	}

	/**
	 * Register an user by login social command
	 * @param {object} clientData The value of document
	 */
	static loginSocialClientRegister(clientData) {
		return post('registrar-login-social')(clientData).then(({ data }) => data)
	}

	/**
	 * Client login simulation
	 */
	static clientSimulate(id) {
		return post(`simular-cliente/${id}`)().then(({ data }) => data)
	}
}
